import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import actions from './actions';

export function* getBrands() {
  yield takeEvery(actions.FETCH_BRANDS_REQUESTED, function* (action) {
    try {
      const brands = yield call(actions.getBrands, action.payload);
      yield put({type: actions.FETCH_BRANDS_SUCCEEDED, brands});
    } catch (error) {
      yield put({type: actions.FETCH_BRANDS_FAILED, error: error.message});
    }
  });
}

export function* searchBrands() {
  yield takeEvery(actions.SEARCH_BRANDS_REQUESTED, function* (action) {
    try {
      const brands = yield call(actions.searchBrands, action.payload);
      yield put({type: actions.SEARCH_BRANDS_SUCCESS, brands});
    } catch (error) {
      yield put({type: actions.SEARCH_BRANDS_FAILED, error: error.message});
    }
  });
}

export function* getBrand() {
  yield takeEvery(actions.FETCH_BRAND_REQUESTED, function* (action) {
    try {
      const brand = yield call(actions.getBrand, action.payload);
      yield put({type: actions.FETCH_BRAND_SUCCEEDED, brand: brand.brand_info});
    } catch (error) {
      yield put({type: actions.FETCH_BRAND_FAILED, error: error.message});
    }
  });
}

export function* deleteBrand() {
  yield takeEvery(actions.DELETE_BRAND_REQUESTED, function* (action) {
    try {
      const brand = yield call(actions.deleteBrand, action.payload);
      yield put({type: actions.DELETE_BRAND_SUCCEEDED, brandDeleted: brand});
    } catch (error) {
      yield put(
          {type: actions.DELETE_BRAND_FAILED, error: error.response.data});
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getBrands),
    fork(searchBrands),
    fork(getBrand),
    fork(deleteBrand),
  ]);
}
